import {
  useQuery,
} from '@tanstack/react-query'

import { singularResourcefulScenarioRequest } from '../requests'

export function useAssetAllocationQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  // NOTE: We should contain a list of scenario resources
  // and reference assets from there
  const assetAllocationRequests = singularResourcefulScenarioRequest(
    scenarioID, 'asset_allocation'
  )

  const assetAllocationQuery = useQuery({
    queryFn: assetAllocationRequests.show,
    queryKey,
    initialData
  })

  const isFetching = assetAllocationQuery.isFetching

  return {
    data: assetAllocationQuery.data,
    status: assetAllocationQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching
  }
}
